// TODO: Add
const POND_ACADEMY_CONTRACT_ADDRESS = "0xebf42b25421aab3f54b2070a18ff142915e1d9d0";

export {
  POND_ACADEMY_CONTRACT_ADDRESS
};